<script lang="ts">
  import Icon from 'src/components/Icon.svelte';
  import RingLoader from 'src/components/loaders/RingLoader.svelte';
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  type Direction = 'left' | 'right';

  export let direction: Direction;
  export let disabled = false;
  export let loading = false;

  $: iconName = `eva-chevron-${direction}-outline`;

  function handleClick() {
    dispatch('click');
  }
</script>

<button
  alt={direction}
  class="navBtn {$$restProps.class || ''}"
  on:click={handleClick}
>
  {#if loading}
    <RingLoader class="ringLoader" color="var(--light-2)" />
  {:else}
    <Icon
      name={iconName}
      color="light-1"
      class={disabled ? 'disabledIcon' : ''}
    />
  {/if}
</button>

<style lang="scss">
  @import '../../../stylesheets/variables.scss';

  $size: 20px;
  $mobileSize: 28px;

  .navBtn {
    display: flex;
    background-color: white;
    border-radius: 50%;
    font-size: $size;
    padding: 4px;
    cursor: pointer;
    border: 0px;

    :global(.disabledIcon) {
      opacity: 0.4;
    }

    :global(.ringLoader) {
      width: $size;
      height: $size;
    }
  }

  @media screen and (max-width: $breakpoint-xs) {
    .navBtn {
      font-size: $mobileSize;
    }

    :global(.ringLoader) {
      width: $mobileSize;
      height: $mobileSize;
    }
  }
</style>
